module.exports = __webpack_public_path__ + "made-purchase.svg?25715978f48d73fa3a95b340cf88bff3";